import { createRouter, createWebHistory } from "vue-router";
import {
  updateMetaTags,
  getMetaTagsForCategoryFromAPI,
  getMetaTagsForProducts,
  getMetaTagsForProduct,
  getMetaTagsForRoute,
  removeProductSchema,
} from "./utils/metaTags";
import AdminPanel from "./components/pages/AdminPanel.vue";
// import Home from './components/pages/Home'
//import NavigationPage from './components/pages/NavigationPage.vue'
// import Cart from './components/pages/Cart'
import Products from "./components/pages/Products";
import EditProduct from "./components/pages/EditProduct.vue";
// import Search from './components/pages/Search'
import SingelOrder from "./components/pages/SingelOrder";
import SingleInvoice from "./components/pages/SingleInvoice";
import CheckOut from "./components/pages/CheckOut.vue";
import PolicyPage from "./components/pages/PolicyPage.vue";
import AboutPage from "./components/pages/AboutPage.vue";
import OrdersAndInvoices from "./components/pages/OrdersAndInvoices";
import Finances from "./components/pages/Finances";
// import ArchiveSideBar from './components/menus/ArchiveSIdeBar'
import OrdersSideBar from "./components/menus/OrdersSideBar";
import InvoicesSideBar from "./components/menus/InvoicesSideBar";
import FinancesSideBar from "./components/menus/FinancesSideBar";
import CartSideBar from "./components/menus/CartSideBar";
// import OrderToAproveSideBar from "./components/menus/OrderToAproveSideBar.vue";
import store from "./store/index";
// import Categories from './components/menus/Categories.vue'
import Cart from "./components/menus/Cart.vue";
import ResetPass from "./components/pages/ResetPass";
import ResponsiveHome from "./components/views/ResponsiveHome.vue";
import AccountPage from "./components/pages/AccountPage.vue";
import ThankYouPage from "./components/pages/ThankYouPage.vue";
import notFoundPage from "./components/pages/notFoundPage.vue";
import {
  resolveProductsNavigation,
  isPendingNavigationModalToggle,
} from "./utils/productModalNavigation";

// import helpers from "../src/services/helpers"
// import { nextTick } from "vue";

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    const {
      productId: toQueryProductId,
      productid: toLegacyQueryProductId,
      ...toQueryWithoutProductId
    } = to.query;
    const {
      productId: fromQueryProductId,
      productid: fromLegacyQueryProductId,
      ...fromQueryWithoutProductId
    } = from.query;

    // Keep scroll position when infinite-scroll paging updates the URL —
    // only when staying on the same listing route. Without the
    // `to.path === from.path` guard, navigating away from a paginated
    // listing (e.g. /products?page=5) to any other page — home via the
    // logo, cart, etc. — would incorrectly preserve the scroll position,
    // since `to.query.page` (undefined on the new route) always differs
    // from `from.query.page`.
    if (
      to.path === from.path &&
      (to.query.page !== from.query.page || "page" in to.query)
    ) {
      return false;
    }

    // Keep scroll position when opening/closing a product modal from the
    // products listing. The URL should change, but the listing should stay
    // put. The (to, from) pair was already classified once in the
    // beforeEach guard below — reuse that result instead of recomputing it
    // here, so the two call sites can never disagree.
    if (isPendingNavigationModalToggle()) {
      return false;
    }

    const isProductModalQueryNavigation =
      to.path === from.path &&
      (toQueryProductId !== fromQueryProductId ||
        toLegacyQueryProductId !== fromLegacyQueryProductId) &&
      JSON.stringify(toQueryWithoutProductId) ===
        JSON.stringify(fromQueryWithoutProductId);

    if (isProductModalQueryNavigation) {
      return false;
    }

    return { top: 0 };
  },
  routes: [
    {
      name: "resetPass",
      path: "/reset-password",
      components: {
        resetPassPage: ResetPass,
        // sideBar: LoginForm,
      },
      // meta: {
      //     redirectToLogin: true,
      // }
    },
    {
      name: "adminPanel",
      path: "/admin-panel",
      components: {
        default: AdminPanel,
      },
      meta: {
        sidebar: false,
        loginRequired: true,
        adminRequired: true,
      },
    },
    {
      path: "/admin/products/:id/edit",
      name: "ProductEdit",
      components: {
        default: EditProduct,
      },
      meta: {
        sidebar: false,
        loginRequired: true,
      },
    },
    {
      name: "home",
      path: "/",
      components: {
        default: ResponsiveHome,
        // sideBar: Cart,
      },
      meta: {
        sidebar: false,
        // loginRequired: true,
      },
    },
    {
      name: "orders",
      path: "/orders/:status?",
      components: {
        default: OrdersAndInvoices,
        sideBar: OrdersSideBar,
      },
      meta: {
        sidebar: false,
        // loginRequired: true,
      },
    },
    {
      name: "invocies",
      path: "/invocies/:status?",
      components: {
        default: OrdersAndInvoices,
        sideBar: InvoicesSideBar,
      },
      meta: {
        sidebar: false,
        loginRequired: true,
      },
    },
    {
      name: "returncustdocs",
      path: "/returncustdocs/:status?",
      components: {
        default: OrdersAndInvoices,
        sideBar: InvoicesSideBar,
      },
      meta: {
        sidebar: false,
        loginRequired: true,
      },
    },
    {
      name: "finances",
      path: "/finances/:status?",
      components: {
        default: Finances,
        sideBar: FinancesSideBar,
      },
      meta: {
        loginRequired: true,
      },
      beforeEnter: async () => {
        try {
          store.dispatch("startLoading", null, { root: true });
          await store.dispatch("Finances/getFinances");
          await store.dispatch("Finances/getCatalogue");
        } catch (error) {
          console.log(error);
        } finally {
          setTimeout(() => {
            store.dispatch("stopLoading", null, { root: true });
          }, 700);
        }
      },
    },
    {
      name: "cart",
      path: "/cart",
      components: {
        default: SingelOrder,
        sideBar: CartSideBar,
      },
      meta: {
        loginRequired: true,
      },
    },
    {
      name: "checkOut",
      path: "/checkOut",
      components: {
        default: CheckOut,
      },
      beforeEnter: async (to, from, next) => {
        try {
          const isCartEmpty = store.getters["Orders/getCartOrderLinesNumber"];
          if (isCartEmpty === 0) {
            next({ name: "home" });
          } else {
            next();
          }
        } catch (error) {
          console.log(error);
        }
      },
      meta: {
        loginRequired: true,
      },
    },
    {
      name: "Products",
      path: "/products/:productId?",
      components: {
        default: Products,
        sideBar: Cart,
        mobileSideBar: Cart,
      },
      meta: {},
    },
    // {
    //     name: 'Search',
    //     path: '/Search/:value',
    //     components: {
    //         default: Search,
    //         sideBar: Categories,
    //     },
    //     meta: {
    //         loginRequired: true,
    //     }
    // },
    // {
    //   name: "Order",
    //   path: "/Order/:ordname",
    //   components: {
    //     default: SingelOrder,
    //     sideBar: OrdersSideBar,
    //   },
    //   meta: {
    //     loginRequired: true,
    //   },
    // },
    // {
    //   name: "Invoice",
    //   path: "/Invoice/:ordname",
    //   components: {
    //     default: SingleInvoice,
    //     sideBar: InvoicesSideBar,
    //   },
    //   meta: {
    //     loginRequired: true,
    //   },
    // },
    {
      name: "policy",
      path: "/policy",
      components: {
        default: PolicyPage,
      },
      meta: {
        loginRequired: false,
      },
    },
    {
      name: "about",
      path: "/about",
      components: {
        default: AboutPage,
      },
      meta: {
        loginRequired: false,
      },
    },
    // {
    //   name: "loginPage",
    //   path: "/login",
    //   components: {
    //     default: OrdersAndInvoices,
    //   },
    // },
    {
      path: "/account",
      meta: {
        loginRequired: true,
      },
      children: [
        {
          path: "orders",
          children: [
            {
              path: "",
              component: AccountPage,
            },
            {
              path: ":orderId",
              component: SingelOrder,
            },
          ],
        },
        {
          path: "invoices",
          children: [
            {
              path: "",
              component: AccountPage,
            },
            {
              path: ":invoiceId",
              component: SingleInvoice,
            },
          ],
        },
      ],
    },
    {
      name: "ThankYouPage",
      path: "/thankyou-page",
      components: {
        default: ThankYouPage,
      },
      meta: {},
    },
    {
      name: "CategoryProducts",
      path: "/:rootCategory/:subCategory?",
      components: {
        default: Products,
        sideBar: Cart,
        mobileSideBar: Cart,
      },
      meta: {},
      beforeEnter: async (to, from, next) => {
        try {
          const rootCategory = to.params.rootCategory;

          // Skip validation for specific known routes
          if (rootCategory === "favorites") {
            return next();
          }

          // Validate that the root category exists
          const rootCategories = store.getters["Category/getRootCategories"];

          // If root categories aren't loaded yet, load them
          if (!rootCategories || rootCategories.length === 0) {
            await store.dispatch("Category/getRootCategories");
          }

          const validRootCategory = store.getters[
            "Category/getRootCategories"
          ].find((rc) => rc.path === rootCategory);

          // If root category doesn't exist, redirect to 404
          if (!validRootCategory) {
            return next({
              path: "/404",
              replace: true,
            });
          }

          // If there's a subcategory, validate it exists
          if (to.params.subCategory) {
            try {
              const categoriesRes = await store.dispatch(
                "Category/getCategories",
                {
                  rootCategory,
                },
              );

              const validSubCategory = categoriesRes.data.find(
                (c) => c.slug === to.params.subCategory,
              );

              if (!validSubCategory) {
                return next({
                  path: "/404",
                  replace: true,
                });
              }
            } catch (error) {
              console.error("Error validating subcategory:", error);
              return next({
                path: "/404",
                replace: true,
              });
            }
          }

          next();
        } catch (error) {
          console.error("Navigation error:", error);
          next({
            path: "/404",
            replace: true,
          });
        }
      },
    },
    {
      path: "/404",
      name: "NotFound",
      components: {
        default: notFoundPage,
      },
      meta: {
        noIndex: true,
      },
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/404",
    },
  ],
});

async function tryToLogin() {
  // console.log('try to login from router.js start')
  // document.getElementById("dolimo_loader").style.display = "flex";
  await store.dispatch("AuthModule/tryLogin");
  // console.log('try to login from router.js done!')
}

// router.afterEach(async () => {
//   setTimeout(async () => {
//     await nextTick();
//     helpers.nagishStyleChanger();
//   }, 100);
// });

// Remove trailing slashes from URLs (except home page)

router.beforeEach((to, from, next) => {
  // Check if path has a trailing slash and is not the home page
  if (to.path !== "/" && to.path.endsWith("/")) {
    // Remove the trailing slash
    const pathWithoutSlash = to.path.slice(0, -1);

    // Redirect to URL without trailing slash, preserving query params
    next({
      path: pathWithoutSlash,
      query: to.query,
      hash: to.hash,
      replace: true, // Use replace to avoid adding to browser history
    });
  } else {
    next();
  }
});

// Canonical product URL redirect:
// Ensures every product is accessed via /products/{productId} with no query params.
router.beforeEach((to, from, next) => {
  // Case 1: /products/{id} with query params → strip them
  const productPathMatch = to.path.match(/^\/products\/(\d+)$/);
  if (productPathMatch && Object.keys(to.query).length > 0) {
    return next({ path: to.path, replace: true });
  }

  // Case 2: Any route with ?productId={id} or ?productid={id} → redirect to /products/{id}
  const queryProductId = to.query.productId || to.query.productid;
  if (queryProductId && /^\d+$/.test(queryProductId)) {
    return next({ path: `/products/${queryProductId}`, replace: true });
  }

  next();
});

// Classify every products/category-listing navigation once, so App.vue's
// router-view :key and scrollBehavior agree on whether this is a modal
// open/close (same listing) or a real navigation to different content.
// Must run after the two guards above so `to` already reflects the final
// canonical path (e.g. /products/123, not a ?productId= query variant).
router.beforeEach((to, from, next) => {
  resolveProductsNavigation(from, to);
  next();
});

router.beforeEach(async function (to, from, next) {
  const isAuthenticated = store.getters["AuthModule/isAuthenticated"];
  try {
    if (!isAuthenticated) {
      if (to.meta.loginRequired) {
        await tryToLogin();
        if (!store.getters["AuthModule/isAuthenticated"]) {
          await store.dispatch("Orders/setCartModel", false);
          return next("/");
        }
      } else {
        await tryToLogin();
      }
    }

    return next();
  } catch (error) {
    console.error("Navigation error:", error);
    return next(false);
  }
});

// Handle meta tags after each route change
router.afterEach(async (to) => {
  let metaTags;
  let includeCanonical = true; // Default to including canonical tag

  if (to.name === "NotFound" || to.path === "/404") {
    includeCanonical = false;
    const robotsTag = document.querySelector('meta[name="robots"]');
    if (robotsTag) {
      robotsTag.setAttribute("content", "noindex, nofollow");
    }
  } else {
    const robotsTag = document.querySelector('meta[name="robots"]');
    if (robotsTag) {
      robotsTag.setAttribute(
        "content",
        "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1",
      );
    }
  }

  // ✅ Check if we have a product modal open (for ANY route)
  const productId = to.query.productId || to.params.productId;
  if (productId) {
    // Handle individual product page regardless of route name
    // Pass root/sub category if available (for CategoryProducts route)
    // Otherwise pass null (for Products route)
    metaTags = await getMetaTagsForProduct(
      store,
      productId,
      to.params.rootCategory || null,
      to.params.subCategory || null,
    );
  } else if (to.name === "CategoryProducts" && to.params.rootCategory) {
    // Remove product schema when navigating away from product
    removeProductSchema();
    // Handle category pages - fetch category data from API to get metaTitle and metaDescription
    metaTags = await getMetaTagsForCategoryFromAPI(
      store,
      to.params.rootCategory,
      to.params.subCategory,
    );
  } else if (to.name === "Products") {
    // Remove product schema when navigating away from product
    removeProductSchema();
    // Handle general products page /products (without productid)
    metaTags = getMetaTagsForProducts();
  } else if (to.name === "about") {
    removeProductSchema();
    metaTags = getMetaTagsForRoute(
      "אודות | RGIFT – מוצרי נוי, אריזות ומתנות לאירועים",
      "RGIFT (ארגיפט 2022) מייבאים ומשווקים מוצרי נוי, אריזות ומוצרים לימי הולדת לעסקים ולבית. הכירו את הסיפור שלנו ולמה לקוחות עסקיים בוחרים בנו שוב ושוב.",
      "/about",
    );
  } else {
    // Remove product schema when navigating away from product
    removeProductSchema();
    // For other pages, set default meta tags with dynamic canonical URL
    metaTags = {
      title:
        "rgift | מוצרי נוי, אגרטלים, עצי פלסטיק מעוצבים, מוצרים לימי הולדת ואריזות בסטייל",
      description:
        "חנות אקססוריז לבית עם מבחר מוצרים: עציצים מפלסטיק, מוצרי אריזה, נרות דקורטיביים ומוצרים לימי הולדת. היכנסו לחנות ובחרו את המוצרים שאתם אוהבים",
    };
  }

  updateMetaTags(
    metaTags.title,
    metaTags.description,
    metaTags.canonicalUrl,
    includeCanonical,
  );
});

export default router;
